module.exports = __webpack_public_path__ + "static/img/Round-18-2009.571dcd6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Round-18-2009.jpg
// module id = FD9E
// module chunks = 0